import { GridRow } from 'ui/indexPages/tables/grid';

import { MinHeightSkeleton } from './Styled';
import { useTableContext } from '../../contexts/Table';

export const testIds = {
  skeletonRow: 'df-table-skeleton-row',
};

export const Skeleton = () => {
  const { columns, gridLayout } = useTableContext();
  return (
    <GridRow gridLayout={gridLayout} data-test={testIds.skeletonRow}>
      {columns.map((col) => (
        <MinHeightSkeleton key={col.id} />
      ))}
    </GridRow>
  );
};
